<template>
  <div class="app-sim-order-status-wrapper" v-if="simOrderStatus_">
    <dyn-slot>
      <slot name="txtBefore"></slot>
    </dyn-slot>
    <SimOrder @refresh="refresh" v-if="simOrderStatus_ === 'DEFAULT'" :show-esim="showEsim">
      <template v-for="slot in possibleChildSlotsFor('OrderWrapper')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </SimOrder>
    <slot name="txtAlreadyActiv" v-if="simOrderStatus_ === 'ACTIVATED'"></slot>
    <SimDelivered v-if="simOrderStatus_ === 'DELIVERED'">
      <template v-for="slot in possibleChildSlotsFor('SimDelivered')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </SimDelivered>
    <slot name="txtOrdered" v-if="simOrderStatus_ === 'ORDERED'"></slot>
    <slot name="txtAfter"></slot>
  </div>
</template>

<script>

import { wrapQuery } from '@/helper/wrapGQLQuery'
import SimDelivered from './SimDelivered.vue'
import SimOrder from './SimOrder.vue'
import gql from 'graphql-tag'
import transaction from '../../../../../../mixins/transaction'
import slotProxy from '../../../../../../mixins/slotProxy'

export default {
  name: 'SimOrderStatusWrapper',
  components: { SimDelivered, SimOrder },
  mixins: [
    transaction('simOrderStatus'),
    slotProxy()
  ],
  data () {
    return {
      simOrderStatus: ''
    }
  },
  methods: {
    refresh () {
      this.$apollo.queries.simOrderStatus.refresh()
    }
  },
  computed: {
    simOrderStatus_ () {
      return this.simOrderStatus.simOrderStatus
    }
  },
  props: {
    showEsim: {
      type: Boolean,
      default: false
    }
  },
  apollo: {
    simOrderStatus: function () {
      return wrapQuery(gql`
      query simOrderStatus {
  simOrderStatus {
      simOrderStatus
    }
}`, this, 'simOrderStatus')
    }
  }
}
</script>
